import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IErrorLog } from '../../../model/error-logs';
import { ILocationContext } from '../../../model/location-context';
import ErrorLogsActions from './store/error-logs.action-types';
import { ErrorLogsState } from './store/error-logs.reducers';
import { errorLogsSelector } from './store/error-logs.selectors';

@Injectable({
    providedIn: 'root'
})
export class ErrorLogsService {
    constructor(private readonly store: Store<ErrorLogsState>) {}

    requestErrorLogs(locationContext: ILocationContext) {
        this.store.dispatch(ErrorLogsActions.requestErrorLogs({ locationContext }));
    }

    loadErrorLogs(errorLogs: IErrorLog[]) {
        this.store.dispatch(ErrorLogsActions.loadErrorLogs({ errorLogs }));
    }

    getErrorLogs(): Observable<IErrorLog[]> {
        return this.store.select(errorLogsSelector);
    }
}
